import React from 'react';
import FormSubmitButton from './FormSubmitButton';
import styled from 'styled-components';


const defaultProps = {
    children: 'Next Step',
};

const StyledSubmitButtonWrapper = styled.div`
    margin-top: ${props => props.theme.unit * 5}px;
`;

const FormStepButton = ({ children, ...rest }) => {
    return (
        <StyledSubmitButtonWrapper>
            <FormSubmitButton {...rest}>
                { children }
            </FormSubmitButton>
        </StyledSubmitButtonWrapper>
    );
};

FormStepButton.defaultProps = defaultProps;

export default FormStepButton;
